import { render, staticRenderFns } from "./tigerzzVideo.vue?vue&type=template&id=feed5f94&scoped=true&"
import script from "./tigerzzVideo.vue?vue&type=script&lang=js&"
export * from "./tigerzzVideo.vue?vue&type=script&lang=js&"
import style0 from "./tigerzzVideo.vue?vue&type=style&index=0&id=feed5f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feed5f94",
  null
  
)

export default component.exports